import docApi from '@/views/page/doctor/api_url'
import nurseApi from '@/views/page/nurse/nurse_api_url'
import drugApi from '@/views/page/drug/drug_api_url'
import chargeApi from '@/views/page/toll/script/charge-api'
import treatmentApi from '@/views/page/technician/script/treatment-api'
import inpatientApi from '@/views/page/live-toll/live-toll-api'
import mineApi from '@/views/page/mine/mine_url'
// 随访
import aiFollowUpApi from '@/views/page/AI-follow-up/script/ai-follow-up-api'

const systemApi = {
  login: '/system-api/webapi/user/login',
  userLogout: '/system-api/webapi/user/logout',
  changePassword: '/system-api/webapi/user/change-password',
  getEntity: '/system-api/webapi/hospital/get-entity',
  // 切换角色
  changeDefaultRole: '/system-api/webapi/user/change-default-role',
  // 获取当前医院
  getCurrentHospital: '/system-api/webapi/hospital/get-current-hospital',
  getHospitalLevel: '/system-api/webapi/dictionary/get-list?table=hospital_level',
  hospitalUpdate: '/system-api/webapi/hospital/update',
  getTree: '/system-api/webapi/specialties-catalog/get-tree',
  departmentGetTree: '/system-api/webapi/department/get-tree',
  specialtiesCatalogGetTree: '/system-api/webapi/specialties-catalog/get-tree',
  departmentInsert: '/system-api/webapi/department/insert',
  departmentGetEntity: '/system-api/webapi/department/get-entity',
  departmentDelete: '/system-api/webapi/department/delete',
  departmentUpdate: '/system-api/webapi/department/update',
  getAreaList: '/gfd-information/get-area-list',
  getContractList: '/gfd-contract/get-contract-list',
  userListAll: '/system-api/webapi/user/list-all',
  // 不使用科室列出用户，用条件列出用户
  // userListAllDepartment: '/system-api/webapi/user/list-users-by-department',
  userListUsesDepartment: '/system-api/webapi/user/list-users',
  userDelete: '/system-api/webapi/user/delete',
  userUpdate: '/system-api/webapi/user/update',
  userInsert: '/system-api/webapi/user/register-as-doctor',
  resetUserPassword: '/system-api/webapi/user/reset-password',
  treatmentInsert: '/system-api/webapi/treatment-info/insert',
  CareerType: '/system-api/webapi/dictionary/get-list?table=career_type',
  medicineInsert: '/system-api/webapi/medicine-info/insert',
  dictionaryTitle: '/system-api/webapi/dictionary/get-list',
  roleInsert: '/system-api/webapi/role/insert',
  roleListAll: '/system-api/webapi/role/list-all',
  roleDelete: '/system-api/webapi/role/delete',
  roleUpdate: '/system-api/webapi/role/update',
  roleListRoles: '/system-api/webapi/role/list-search',
  listChapter: '/system-api/webapi/dd-icd10-hospital/list-chapter',
  icd10Insert: '/system-api/webapi/dd-icd10-hospital/insert',
  icd10ListIcd10s: '/system-api/webapi/dd-icd10-hospital/list-icd10s',
  icd10Delete: '/system-api/webapi/dd-icd10-hospital/delete',
  icd10Update: '/system-api/webapi/dd-icd10-hospital/update',
  icd9ListIcd9Cm3s: '/system-api/webapi/ddIcd9Cm3Hospital/listSearch',
  icd9Insert: '/system-api/webapi/ddIcd9Cm3Hospital/insert',
  icd9Update: '/system-api/webapi/ddIcd9Cm3Hospital/update',
  icd9Delete: '/system-api/webapi/ddIcd9Cm3Hospital/delete',
  searchcommon: '/system-api/webapi/dictionary/search-common',
  deleteCommon: '/system-api/webapi/dictionary/delete-common',
  updateCommon: '/system-api/webapi/dictionary/update-common',
  insertCommon: '/system-api/webapi/dictionary/insert-common',
  roleId: '/system-api/webapi/power/list-role-by-user-id',
  roleAuthorize: '/system-api/webapi/power/authorize-role-to-user',
  rolePower: '/system-api/webapi/power/list-power-by-role-id',
  roleFunction: '/system-api/webapi/power/authorize-power-function-to-role',
  updateHospital: '/system-api/webapi/specialties-catalog/update-hospital-catalog',
  costGetTree: '/system-api/webapi/dd-cost-category/list-search',
  delTreeItem: '/system-api/webapi/dd-cost-category/delete',
  modTreeItem: '/system-api/webapi/dd-cost-category/update',
  addTreeItem: '/system-api/webapi/dd-cost-category/insert',
  tableListSearch: '/system-api/webapi/dd-treatment-medicine-insurance/list-search',
  mainTableListSearch: '/system-api/webapi/treatment-info/list-search',
  mainTableListSearchDetail: '/system-api/webapi/treatment-info/get',
  mainTableListUpdate: '/system-api/webapi/treatment-info/update',
  mainTableListDelete: '/system-api/webapi/treatment-info/delete',
  deptList: '/system-api/webapi/department/list-clinical-laboratory',
  dictionaryWithCondition: '/system-api/webapi/dictionary/search-common',
  testDetail: '/system-api/webapi/treatment-info-item/list-search',
  medicineTableList: '/system-api/webapi/dd-medicine-insurance/list-search',
  mediRightTableSearch: '/system-api/webapi/medicine-info/list-search',
  mediRightTableSearchDetail: '/system-api/webapi/medicine-info/get',
  mediRightTableUpdate: '/system-api/webapi/medicine-info/update',
  mediRightTableDelete: '/system-api/webapi/medicine-info/delete',
  medHcCateDelete: '/system-api/webapi/dd-medicine-insurance/delete',
  medHcCateAdd: '/system-api/webapi/dd-medicine-insurance/insert',
  medHcCateModify: '/system-api/webapi/dd-medicine-insurance/update',
  treatHcCateDelete: '/system-api/webapi/dd-treatment-medicine-insurance/delete',
  treatHcCateAdd: '/system-api/webapi/dd-treatment-medicine-insurance/insert',
  treatHcCateModify: '/system-api/webapi/dd-treatment-medicine-insurance/update',
  treatLeftSearch: '/system-api/webapi/treatment-group-info/list-tree',
  treatLeftAdd: '/system-api/webapi/treatment-group-info/insert',
  treatLeftModify: '/system-api/webapi/treatment-group-info/update',
  treatLeftDelete: '/system-api/webapi/treatment-group-info/delete',
  treatRightSearch: '/system-api/webapi/treatment-group-relation/list-search',
  treatRightDelete: '/system-api/webapi/treatment-group-relation/delete',
  treatRightAdd: '/system-api/webapi/treatment-group-relation/insert',
  treatRightEdit: '/system-api/webapi/treatment-group-relation/update',
  insertReceiptType: '/system-api/webapi/dd-receipt-type/insert',
  updateReceiptType: '/system-api/webapi/dd-receipt-type/update',
  deleteReceiptType: '/system-api/webapi/dd-receipt-type/delete',
  getReceiptType: '/system-api/webapi/dd-receipt-type/list-search',
  insertTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/insert',
  updateTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/update',
  deleteTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/delete',
  getTreatmentGroupCategory: '/system-api/webapi/dd-treatment-group-category/list-search',
  listSearch: '/system-api/webapi/patient/list-search',
  insertPatient: '/system-api/webapi/patient/insert',
  systemApiUpdatePatient: '/system-api/webapi/patient/update',
  getPatient: '/system-api/webapi/patient/get',
  getByCode: '/system-api/webapi/biConfig/getByCode'
}

const DBApi = {
  DBApi: {
    getEmrKnowledgeGroupNameAndTitle: '7b71d731-1cf6-4d81-a7d0-f9c84108b293',
    getEmrKnowledgeByCategory: 'cfc55a31-f930-42f9-b60f-09afd4eed0be',
    getEmrKnowledgeById: '8cd6e26e-262a-48ae-9221-55977c9b545d',
    addEmrKnowledge: '657299ad-b117-425a-a8fb-8bd91ce5b22f', // 新增知识库
    updateEmrKnowledge: 'ac2ad630-bb14-4ea8-b7d9-e4506fdaa031', // 更新知识库
    getEmrKnowledgeGroup: '161b6dcd-8892-4a41-ba96-17a4acac1c08', // 查询分组
    delEmrKnowledge: '79657f56-7730-44c2-be33-1e36288cd587',
    operationTemplateDetails: '5757802c-5aa8-4f25-96da-f9ce3e6e6d68',
    getDrugsLimit: 'f29bb467-40ca-4ca1-9044-cb139322d03c',

    getVersion: 'fd20feea-09fd-4b0e-8e6f-b09c00fd3178',

    ioTreatmentParentPrefect: {
      getUltrasoundList: '35124cbe-385b-428a-9511-793df381f38c',
      getElectrocardiogramList: '3382a2be-7f7d-42c4-a807-9dfc3a8fce21',
      removeUltrasound: 'bd41dd52-4030-4aaa-85cd-b168bd4c13e4',
      update: '8d462ada-5ecc-4f75-9c46-267c953a76f1'
    },
    // 体温单-批量
    emrThreeTestRecord: {
      batchAdd: '29a4d9cb-1391-4519-89d1-a189a33efcd4',
      list: 'd3907ca2-6a51-41d4-9d7f-199885d55ff6',
      del: 'd8ba2e43-c371-483b-93c5-637ad626fe99'
    },
    emrOutpatientPhrase: {
      listByTypeAndTitle: 'd5f31663-202b-4cf1-92e1-56781296b4cf'
    },
    emrInpatientRecord: {
      add: '06c4cd3e-4e43-4bb3-b20e-a2140c583e1c',
      get: '9fff83c7-d833-47bb-93e7-1152f72a45fa',
      search: '9485f79e-0d73-4a60-a750-961ac70a40c8'
    },
    emrInpatientAdviceTemplate: {
      get: 'b1d0e746-e7a0-4e65-99b8-7b48a4c0c501',
      delItem: '42fd5a32-cb5d-42de-9368-502a8b447721',
      updateItem: '3ab6541d-3c6c-4e75-85d7-be3217f0ba7c',
      addItem: '6f8e70b4-a8a5-4b23-8067-e214e8c50ca9',
      list: '102f33c4-9618-46a1-ba1a-379f44b2e8d4',
      getAllItem: '61241642-dd74-499b-b9fc-dd7655e1a0b4'
    },
    outpatientRecord: {
      getPopulationClassification: '558ef463-1a60-461b-9d55-ce936bcc5de1',
      getIncompleteRecords: '03fbf8f5-cf4d-42dd-a201-dccb492fa6ec',
      getTpTemplateById: '64640482-52fe-4ec3-a791-40da0714fdd5',
      getPayBillsDetails: 'a1d7e9e8-4933-4e83-8d47-24c51689580c',
      getTreatmentPayStatus: '8301242d-2f4e-46f1-ad04-6456bc4fc3ce',
      get24hoursOutpatientRecord: '5259d030-b298-4c7c-91d3-1fc56413af25',
      addOutpatientFollowupRecord: '4aade2f6-3af2-4cba-948d-5b330236ea51',
      checkDiagnosis: '19eb767d-c042-48be-8217-ae9e586aca3e',
      checkDiagnosisByReceipt: '2abe4b6b-6b94-441f-9c17-dfefaa596562',
      checkMTCT: '9a0e9842-e57e-4b48-801d-dc202ad08b1d',
      getReports: 'a6852ac7-7c09-4494-91e7-c752693453d5',
      getOutpatientRecords: 'bb2ee31a-30a3-40fd-8d8b-c63306f11ccc',
      getOutpatientEmr: '0e2f15f8-cf2c-4198-9bf5-1e1d108444c4',
      update: 'a71e5568-33a6-405e-b59b-9ab6a1959e54'
    },
    inpatientRecord: {
      getParentBed: '656d3dce-15c0-4a49-8c9a-c7e29267b36b', // 获取获取婴儿可选床位ABCDE
      getUnexecutedOrders: '2b43958b-f30f-4334-bd0b-a7129cd0dd18', // 获取没核对和没执行的医嘱
      getDiagnosisListByRecordId: 'c188e432-9291-4e2b-bb79-92ac05ccd5cb', // 查询诊断
      getOperationListByRecordId: 'ff236bb2-c22a-4bbc-aa18-f0aab6c1832c',
      cancel: 'ca8d0d57-b07e-4d2d-a884-9f4055e49dd9', // 取消入院
      checkAdviceOrder: 'ccec7c4d-3495-4876-9134-d49f4aab35e5'
    },
    inpatientAdviceOrder: {
      writeRemark: '204c960d-c496-4a8c-9680-905374a5e64f'
    },
    warehouseManage: {
      traceabilityCodeOfSubject: '81eac359-e634-4d7e-b6fa-0d1ab4a1a917',
      storeDetail: 'daf25043-e0cf-4d1f-afe0-ec32d1065c76',
      getLastInSubject: '6772fea2-390d-455f-9b78-469206078593',
      getAllSubjectList: '848a792b-d6be-4424-828b-7d489416bc76', // 库存明细
      storeDetailForStock: 'eb49dcc4-7271-4278-8e65-aa602b49f334',
      storeDetailForVendor: '2fc3a453-d23c-405e-a068-a792937e637b',
      getManagementDetail: 'c7dddb7b-0e25-4295-bcd3-c6e9c20b0e36',
      officeBatch: '360dea06-7428-48fb-85e2-0783180afb9d'
    },
    treatmentInfo: {
      getMaxWarehouseCode: 'a430a924-5a67-4f67-ab01-d986b4c69de7',
      getGroupList: 'bd7b9a4f-082b-4551-964a-93fb78c2cc90',
      enabledGroupInfo: '86d4d35d-a09d-4d0e-8d96-670e0bd7bdf9',
      disabledGroupInfo: '7302d1b6-8ebd-4017-b2b1-61714428b45c',
      updateGroupSn: 'c42c881b-c614-42c3-a006-46e28a00266b'
    },
    medicalRecordTemplate: {
      templateList: '9f7de0a0-e730-49f7-b560-13cc521f0743',
      writList: 'baf7ced2-3d92-4bad-aaf3-0b654edadef3',
      add: '79397269-b6ad-47e4-b4cc-eb4bd09f1902',
      get: '71b7327e-4cbb-4281-8cd5-04e362af885b',
      getGroupList: 'b8bf0501-9c41-47fd-b1f6-499cf9621f80',
      update: 'c0332302-9ec6-4a2c-96b9-eb1c14a22676',
      delete: 'ffa55077-2144-4d82-b86d-5b4bf20b5fa0'
    },
    emrMetadata: {
      list: '8575b2b5-a099-4fb8-89e7-2528ddc19bb8',
      get: '887a8440-6089-489c-a728-d90344df80c2',
      insert: '2239c90e-ee2e-4571-a6d5-8f18a37fc9e0',
      update: 'c5b2286b-fed6-4934-8c73-1dfb8bf458d0',
      delete: '93216e0a-83a6-422f-8a6f-894aea7cc82c',
      categories: '94edc16d-d89b-4a19-95af-f4a6ecfb4203'
    },
    medicalRecord: {
      get: '994a65c4-0de5-41cd-ae77-38fe889790c1',
      update: '89feb37a-245d-43d2-925b-9a31a2c2403e',
      auth: 'fddeb7fd-3bd0-422c-b92c-31700034267e',
      authCodes: 'e08c9a89-8421-4990-9a53-0e2de8d5f119',
      list: '84370a95-e910-4096-be11-8015e59bf794',
      BASY: '36c652cf-3b70-4573-88f7-5a726bbce8c5'
    },
    treatmentChargeSetting: {
      getSubjectTree: '9ac8e5ea-bdcf-4ffe-a6df-485ff0d35f6f',
      getList: '3ec45545-98bb-4092-a34c-a4446fba2b44',
      insert: '7f01ad1a-a9a5-4598-82dc-913e1b897b56',
      update: 'da637c63-30f7-4aeb-ac6e-d32fb1e4417a',
      delete: '668be0b3-a81b-47ef-b7c6-91dcb60f923f'
    },
    biConfig: {
      add: 'c9573d7e-fe30-42a6-b583-51e21160d8c6',
      update: 'd5e71dc4-dde9-47b5-b429-ec80d80ca0c4',
      delete: 'f37d8def-d51a-4936-abf3-0a276cf059e5',
      getList: 'aa7fdca5-9f42-4334-ab2f-bb8c6322c155',
      getById: 'cc83cd2a-82bc-459c-b8e3-d5c56f1a8fb9'
    },
    inpatientStandNurseCheck: {
      get: '77254d49-6251-4a6f-bf8a-aea6adcc2db7',
      updateTime: '0bf74bec-5eee-4d3b-9014-7c5265b8e464'
    },
    inpatientRecordDiagnosis: {
      swap: '4fb4a473-7bdb-4d23-8573-914c90178e2b'
    },
    userSign: {
      getByName: '871451fa-cc2d-4f12-9d38-57e6a29e30f3'
    },
    patient: {
      getExtById: '8306efd6-e253-4deb-8f85-8e17aadf238d',
      updateExt: '67d38792-9714-4ede-b238-4ca550840a0a'
    },
    hivTestRegister: {
      list: '02371d82-45d3-4295-b5c7-6b11c87fe4ac',
      insert: '33724974-bfbc-41da-a748-a6894336d19b',
      update: '47c8698f-1497-492f-993c-b3fcd50a1894',
      delete: '6c10c51c-a1b0-4e18-93ed-fc45f2327baa',
      getSeqNo: '1352ab58-616d-46e3-803b-e6f681df3249'
    },
    hivReferralRegister: {
      list: '3035c733-3ecd-4da4-b947-beea8d07546b',
      insert: '592e3f06-d986-4bd1-a346-9eda5d45f934',
      update: '5246dfb1-f6d5-439e-8e7c-ead6d146dace',
      delete: '3b3e7736-4608-46f4-969e-71dc8614c989'
    },
    drugs: {
      getIoPharmacyDetailsPrefect: '1075707a-1ab0-4243-ba57-8030727fbe01'
    }
  }
}

const requestApi = Object.assign(systemApi, docApi, nurseApi, drugApi, chargeApi, treatmentApi, mineApi, inpatientApi, aiFollowUpApi, DBApi)

export default requestApi
